import { z } from "zod";

// Standalone email validator used by the referral flow to validate addresses
// as the user types (no form wrapper). `safeParse` is the expected API.
export const emailSchema = z.string().email();
